import { m } from '@sohanscript/i18n';
import type { NotFoundRouteComponent } from '@tanstack/react-router';
import type { ComponentProps } from 'react';
import { ErrorComponent } from './error';
import { Footer } from './layout/footer';
import { Navbar } from './layout/navbar';

function hasMessage(data: unknown): data is { message: string } {
	return (
		typeof data === 'object' &&
		data !== null &&
		'message' in data &&
		typeof data.message === 'string'
	);
}

export function NotFoundPage({ data }: ComponentProps<NotFoundRouteComponent>) {
	return (
		<>
			<Navbar />
			<ErrorComponent
				message={hasMessage(data) ? data.message : m.nf_page_not_found()}
			/>
			<Footer />
		</>
	);
}
